import { render, staticRenderFns } from "./GasEditor.vue?vue&type=template&id=72dd7186&scoped=true&"
import script from "./GasEditor.vue?vue&type=script&lang=js&"
export * from "./GasEditor.vue?vue&type=script&lang=js&"
import style0 from "./GasEditor.vue?vue&type=style&index=0&id=72dd7186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd7186",
  null
  
)

export default component.exports